import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Package.css';

const PackageComponent = ({ title, heading, description, image, price, duration, details }) => {
    useEffect(() => {
        document.title = title;

        const metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        metaDescription.content = typeof description === "string" ? description : "";
        document.head.appendChild(metaDescription);

        const structuredData = {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": title,
            "image": image,
            "description": typeof description === "string" ? description : "",
            "offers": {
                "@type": "Offer",
                "priceCurrency": "SEK",
                "price": price
            }
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(structuredData);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(metaDescription);
            document.head.removeChild(script);
        };
    }, [title, description, image, price]);

    return (
        <div className="package-container">
            <section className="content">
                {heading && <h1 className="about-title">{heading}</h1>}

                <div className="image-wrapper">
                    <img src={image} alt={title} className="package-image" />
                    <div className="dark-overlay"></div>
                </div>

                <div className="package-description">
                    {description}
                </div>

                <h2>Paket Innehåll </h2>
                <ul className="package-details">
                    {details.map((detail, index) => (
                        <li key={index}><strong>{detail.label}:</strong> {detail.value}</li>
                    ))}
                </ul>

                <div className="button-wrapper">
                    <Link to="/Boka" className="action-button">
                        Boka Nu
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default PackageComponent;
